import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Subject, takeUntil } from 'rxjs';
import { SanitizerPipe } from 'src/app/shared/pipes';
import { CurrentFacilityService, SessionService } from 'src/app/shared/services';
import { AutoPayFormGroupType } from '../auto-pay/models/auto-pay-form';
import { AwbSubscriptionService } from '../services/awb-subscription.service';

@Component({
    selector: 'app-auto-pay-policy',
    standalone: true,
    imports: [MatCheckboxModule, SanitizerPipe],
    templateUrl: './auto-pay-policy.component.html',
    styleUrl: './auto-pay-policy.component.scss',
})
export class AutoPayPolicyComponent implements OnInit, OnDestroy {
    public isAuthenticated: boolean;
    public autoPayForm: AutoPayFormGroupType;
    public selectedNote = false;
    public selectedTermsOfUse = false;
    public termsOfUseURL: string;
    public showNotes = false;

    private unsubscribe$: Subject<void>;

    get isSelectedAutoPay(): AbstractControl<boolean> | null {
        return this.autoPayForm?.get('isSelected');
    }

    constructor(
        private sessionService: SessionService,
        private awbSubscriptionService: AwbSubscriptionService,
        private currentFacilityService: CurrentFacilityService
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.subscribeIsAuthenticated();
        this.subscribeAutoPay();
        this.getTermsOfUseUrl();
        this.subscribeIsValidAutoPay();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribeIsAuthenticated(): void {
        this.sessionService
            .isAuthenticated$()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (isAuthenticated: boolean) => {
                    this.isAuthenticated = isAuthenticated;
                },
            });
    }

    subscribeAutoPay(): void {
        this.awbSubscriptionService
            .getAutoPayForm()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((isEnableAutoPay) => {
                this.autoPayForm = isEnableAutoPay;
            });
    }

    acceptNotes(isSelected: boolean): void {
        this.selectedNote = isSelected;
        this.awbSubscriptionService.setPolicy(this.selectedNote && this.selectedTermsOfUse);
    }

    acceptTermsOfUse(isSelected: boolean): void {
        this.selectedTermsOfUse = isSelected;
        this.awbSubscriptionService.setPolicy(this.selectedNote && this.selectedTermsOfUse);
    }

    getTermsOfUseUrl(): void {
        this.termsOfUseURL = this.currentFacilityService.getTermsOfUseURL();
    }

    subscribeIsValidAutoPay(): void {
        this.awbSubscriptionService
            .isValidAutoPay()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (isValidAutoPay) => {
                    if (!this.autoPayForm?.get('isSelected')?.value) {
                        this.showNotes = false;
                    } else {
                        this.showNotes = isValidAutoPay;
                    }
                },
            });
    }
}
